<template>
  <div>
    <el-form
      size="mini"
      class="drawer-form"
      :model="editClassForm"
      label-width="88px"
      ref="drawerForm2"
      :rules="rules"
    >
      <div class="block">
        <p class="title">基本信息</p>
        <el-form-item label="班级名称:" prop="name">
          <el-input
            v-model="editClassForm.name"
            placeholder="请输入"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="排课课程:">
          <el-input
            :value="originData.course_list[0].title"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="班级简称:" prop="sub_name" class="class-sub">
          <el-input
            placeholder="请完善下列信息生成班级简称"
            v-model="editClassForm.sub_name"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item prop="subject_id">
          <el-select
            v-model="editClassForm.subject_id"
            placeholder="请选择课程科目"
            @change="handleSubjectChange"
          >
            <el-option
              v-for="item in subjectList"
              :key="item.subject_id"
              :label="item.subject_title"
              :value="item.subject_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="course_category_ids">
          <el-select
            v-model="editClassForm.course_category_ids"
            placeholder="请选择课程类型"
            multiple
            ref="courseTypeSelectRef"
            @change="handleCategoryChange"
          >
            <!-- 1vN，小组课默认选中，不能取消，定制课不可选 -->
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="item.id === 2 || item.id === 1"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 课程类型为 小组课 或 练习课 时显示课程级别 -->
        <el-form-item
          prop="course_level_id"
          v-if="
            editClassForm.course_category_ids.includes(1) ||
            editClassForm.course_category_ids.includes(5)
          "
        >
          <el-select
            v-model="editClassForm.course_level_id"
            placeholder="请选择课程级别"
            @change="handleLevelChange"
          >
            <el-option
              v-for="item in levelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班级学员:">
          <el-input :value="originData.student.name" disabled></el-input>
        </el-form-item>

        <el-form-item label="排课课时:" prop="consume_number">
          <el-col :span="20">
            <el-input
              v-model="editClassForm.consume_number"
              placeholder="请输入"
              type="number"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-tooltip
              effect="dark"
              content="设置后，本班每次点名时，学员消耗的课时数"
              placement="top"
            >
              <i class="tips-icon el-icon-question"></i>
            </el-tooltip>
          </el-col>
        </el-form-item>
      </div>
      <div class="block">
        <p class="title">其他信息</p>
        <el-form-item label="授课教师:" prop="teacher_ids">
          <!-- <all-teacher-selector
            :single="true"
            :originIds.sync="editClassForm.teacher_ids"
            :originItems.sync="originData.teacher_list"
          ></all-teacher-selector> -->
          <div class="mwow-common-form-multi-select">
            <div class="input-wrap">
              <p class="text">
                已添加<span class="mwow-green">{{
                  currentSelectTeacher.length
                }}</span
                >人
              </p>
              <all-teacher-selector
                :origin-data="currentSelectTeacher"
                @change="handleTeacherSelect"
                :single="true"
              >
                <el-button class="mwow-button success">添加</el-button>
              </all-teacher-selector>
            </div>
            <div class="show-wrap" v-show="currentSelectTeacher.length > 0">
              <span
                v-for="item in currentSelectTeacher"
                :key="item.teacher_id"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="20">
            <el-form-item label="上课教室:">
              <el-select
                v-model="editClassForm.classroom_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchClassRoom"
                @change="changeClassRoom"
              >
                <el-option
                  v-for="item in searchClassRoomList"
                  :key="item.classroom_id"
                  :label="item.name"
                  :value="item.classroom_id"
                >
                </el-option>
              </el-select>
              <span class="max-people" v-if="classRoomPeople !== 0"
                >最多可容纳 {{ classRoomPeople }}人</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="mwow-green add-class-room" @click="showAddClassRoom">
              新增
            </div>
          </el-col>
        </el-row>
        <el-form-item label="备注:" prop="remark">
          <el-input
            v-model="editClassForm.remark"
            placeholder="请输入"
            type="textarea"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </div>
      <div class="btns">
        <el-button class="mwow-button-filled" @click="hideEditClassDialog"
          >取消</el-button
        >
        <el-button
          class="mwow-button-filled success"
          @click="handleEditClassSubmit"
          >保存</el-button
        >
      </div>
    </el-form>
    <!-- 抽屉 -->
    <el-drawer
      title="添加教室"
      :visible.sync="addClassRoomDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
      append-to-body
    >
      <add-dialog
        :visible.sync="addClassRoomDrawerVisible"
        :edit-info="''"
        @addClassRoomId="classRoomAddId"
      ></add-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import {
  editClass,
  getCourseSubjectListApi,
  getCourseCategoryListApi,
  getCourseLevelListApi,
} from "@/api/classManagement";
import { classroomSelectListApi } from "@/api/classRoom";
import { pricePass } from "@/utils/rules";
import allTeacherSelector from "../classList/allTeacherSelector.vue";
import addDialog from "@/components/addClassRoomDialog.vue";

export default {
  name: "singleEditDialog",
  components: {
    allTeacherSelector,
    addDialog,
  },
  // @Prop() visible!: boolean;
  // @Prop() originData!: any;
  props: ["visible", "originData"],
  data() {
    return {
      editClassForm: {
        class_id: 0,
        course_type: 2,
        student_id: "",
        course_ids: [],
        main_course_id: 0,
        name: "",
        teacher_ids: [],
        student_excess: 2,
        preset_student_count: 1,
        consume_number: "",
        remark: "",
        classroom_id: "",
        subject_id: "", // 课程科目
        course_category_ids: [], // 课程类型 多选初始值为 []
        course_level_id: "", // 课程级别
        sub_name: "", // 班级简称
      },
      subjectList: [],
      categoryList: [],
      levelList: [],
      subjectAbbr: "",
      categoryAbbr: "",
      levelAbbr: "",
      searchClassRoomList: [],
      classRoomPeople: 0, // 可容纳人数
      addClassRoomDrawerVisible: false,
      rules: {
        student_id: [
          { required: true, message: "请选择学员", trigger: "change" },
        ],
        course_ids: [
          { required: true, message: "请选择课程", trigger: "change" },
        ],
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
        course_category_ids: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        course_level_id: [
          { required: true, message: "请选择级别", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
        teacher_ids: [],
        consume_number: [
          { required: true, message: "请填写排课课时", trigger: "blur" },
          { validator: pricePass, trigger: "blur" },
        ],
      },
      currentSelectTeacher: [],
    };
  },

  created() {
    const courseIds = [];
    this.originData.course_list.map((item) => {
      courseIds.push(item.course_id);
    });
    this.editClassForm = {
      class_id: this.originData.class_id,
      course_type: this.originData.course_type,
      student_id: this.originData.student.student_id,
      course_ids: courseIds,
      main_course_id:
        this.originData.main_course_id ||
        this.originData.course_list[0].course_id,
      name: this.originData.name,
      teacher_ids: this.originData.teacher_list[0]
        ? [this.originData.teacher_list[0].teacher_id]
        : [],
      student_excess: this.originData.student_excess,
      preset_student_count: this.originData.preset_student_count,
      consume_number: this.originData.consume_number,
      remark: this.originData.remark,
      subject_id: this.originData.subject_id ? this.originData.subject_id : "",
      course_level_id: this.originData.course_level_id
        ? this.originData.course_level_id
        : "",
      // 如果没有课程类型，默认选中定制课
      course_category_ids:
        this.originData.course_category_ids.length > 0
          ? this.originData.course_category_ids
          : [2],
      sub_name: this.originData.sub_name,
    };
    this.currentSelectTeacher = this.originData.teacher_list;
    if (this.originData.classroom) {
      this.editClassForm.classroom_id = Number(
        this.originData.classroom.classroom_id
      );
    }
    this.handleSearchClassRoom("");
    eventBus.$on("initClassRoomManagement", () => {
      this.handleSearchClassRoom("");
    });
    this.getSubjectsList();
    this.getCourseCategoryList();
    this.getCourseLevelList();
  },
  methods: {
    beforeDestroy() {
      eventBus.$off("initClassRoomManagement");
    },
    classRoomAddId(id) {
      this.editClassForm.classroom_id = id;
    },
    handleSearchClassRoom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
          this.changeClassRoom(this.editClassForm.classroom_id);
        }
      });
    },
    handleSearchCourseChange() {
      this.editClassForm.student_id = "";
    },
    hideEditClassDialog() {
      this.$emit("update:visible", false);
    },
    handleTeacherSelect(arr) {
      this.currentSelectTeacher = arr;
      this.editClassForm.teacher_ids = arr.map((item) => {
        return item.teacher_id;
      });
    },
    showAddClassRoom() {
      this.addClassRoomDrawerVisible = true;
    },
    changeClassRoom(i) {
      if (!this.editClassForm.classroom_id) {
        this.classRoomPeople = 0;
      }
      this.searchClassRoomList.map((item) => {
        if (item.classroom_id === i) {
          this.classRoomPeople = item.people;
        }
      });
    },
    handleEditClassSubmit() {
      this.$refs["drawerForm2"].validate((valid) => {
        if (valid) {
          const option = this.editClassForm;
          if (option.classroom_id === "" || option.classroom_id === undefined) {
            option.classroom_id = 0;
          }
          // 如果课程级别不存在，则不传
          if (!option.course_level_id) {
            delete option.course_level_id;
          }
          option.consume_number = option.consume_number || "0";
          editClass(option).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.hideEditClassDialog();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败!" + res.message,
              });
            }
          });
        }
      });
    },
    getSubjectsList() {
      getCourseSubjectListApi({
        page: 1,
        page_size: 50,
      }).then((res) => {
        if (res.error_code === 0) {
          // 自定义的课程科目 preset_id 为 0
          res.data.list.forEach((item, index) => {
            if (item.preset_id > 0) {
              let obj;
              res.data.subject_preset.filter((it) => {
                if (item.preset_id === it.preset_id) {
                  obj = it;
                }
                return;
              });
              item.subject_title =
                item.subject_title + (obj.abbr ? `(${obj.abbr})` : "");
            }
          });
          this.subjectList = res.data.list;
          console.log(this.subjectList);
          this.subjectPreset = res.data.subject_preset;
          this.handleSubjectChange();
        }
      });
    },
    getCourseCategoryList() {
      getCourseCategoryListApi().then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.name = item.name + `(${item.abbr})`;
          });
          this.categoryList = res.data.list;
          // 默认选中小组课
          this.categoryAbbr = this.categoryList[1].abbr;
          // 找到小组课 dom，将其 close icon 隐藏掉
          this.$nextTick(() => {
            let courseTypeSelectRef = this.$refs["courseTypeSelectRef"];
            let tags =
              courseTypeSelectRef.$el.querySelector(".el-select__tags");
            let tags_text = tags.querySelector(".el-select__tags-text");
            if (tags_text.innerHTML === `${this.categoryList[1].name}`) {
              let tags_colse = tags_text.nextSibling;
              tags_colse.style.display = "none";
            }
          });
          this.handleCategoryChange();
        }
      });
    },
    getCourseLevelList() {
      getCourseLevelListApi().then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.name = item.name + `(${item.abbr})`;
          });
          this.levelList = res.data.list;
          this.handleLevelChange();
        }
      });
    },
    handleSubjectChange() {
      // 自定义的课程科目 preset_id 为 0
      this.subjectAbbr = "";
      let selPresetId;
      this.subjectList.filter((item) => {
        if (item.subject_id === this.editClassForm.subject_id) {
          selPresetId = item.preset_id;
          return;
        }
      });
      this.subjectPreset.filter((it) => {
        if (selPresetId === it.preset_id) {
          this.subjectAbbr += it.abbr;
          return;
        }
      });
      this.handleClassSub();
    },
    handleCategoryChange() {
      this.categoryAbbr = "";
      this.editClassForm.course_category_ids.forEach((item) => {
        this.categoryList.filter((it) => {
          if (item === it.id) {
            this.categoryAbbr += it.abbr;
            return;
          }
        });
      });
      this.handleClassSub();
    },
    handleLevelChange() {
      this.levelAbbr = "";
      this.levelList.filter((it) => {
        if (this.editClassForm.course_level_id === it.id) {
          this.levelAbbr += it.abbr;
          return;
        }
      });
      this.handleClassSub();
    },
    // 统一按顺序拼接班级简称
    handleClassSub() {
      if (this.editClassForm.course_category_ids.includes(5)) {
        if (this.categoryAbbr && this.levelAbbr) {
          this.editClassForm.sub_name = "";
          this.editClassForm.sub_name +=
            this.subjectAbbr + this.categoryAbbr + this.levelAbbr;
        }
      } else {
        if (this.categoryAbbr) {
          this.editClassForm.sub_name = "";
          this.editClassForm.sub_name +=
            this.subjectAbbr + this.categoryAbbr + this.levelAbbr;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-icon {
  font-size: 14px;
}

.el-select-dropdown {
  .is-disabled {
    color: #c2c3c4 !important;
  }
}
/deep/ .drawer-form {
  .class-sub {
    .el-form-item__label {
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    input {
      border: none;
      background: white !important;
      padding: 0 5px;
      &:hover {
        cursor: default;
      }
    }
  }
}
</style>
